import React, { useEffect } from 'react';
import { useParams, Link } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import createTrack from 'services/actions/tracker_actions';
import { detailed_contract } from 'store/modules/contract_analysis/actions';
import { ApplicationState } from 'store';
import { ContractsAnalysisState } from 'store/modules/contract_analysis/types';
import Loader from 'components/atoms/loader';
import ContractAnalysisReport from 'components/organisms/contract_analysis_report';
import AmbassadorToolFeedback from 'components/molecules/ambassador_tool_feedback';
import { CONTRACT_CLAUSES_AMBASSADOR_SLUG } from 'services/ambassador_tools';

const DetailedContractAnalysis = () => {
  const dispatch = useDispatch();
  const { id } = useParams<{ id: string }>();

  const { contract_analysis, request } = useSelector<ApplicationState, ContractsAnalysisState>(
    (state) => state.session.contract_analysis,
  );

  useEffect(() => {
    document.title = 'Análise detalhada do contrato - ConLicitação';
    if (id) dispatch(detailed_contract(id));
  }, [id, dispatch]);

  if (request?.detailed_contract?.loading) {
    return <Loader />;
  }

  if (request?.detailed_contract?.error) {
    return (
      <div className="page-container">
        <div className="container py-5">
          <div className="row justify-content-center">
            <div className="col-md-6 text-center">
              <div
                className="mx-auto rounded-circle d-flex align-items-center justify-content-center bg-danger"
                style={{ width: 120, height: 120 }}
              >
                <i className="material-icons text-white" style={{ fontSize: 60 }}>
                  error
                </i>
              </div>
              <h4 className="mt-4 text-danger font-weight-bold">Acesso negado</h4>
              <p className="text-muted">
                Você não tem permissão para visualizar esta análise de contrato.
              </p>
              <Link to="/validar_contrato" className="btn btn-primary">
                Voltar
              </Link>
            </div>
          </div>
        </div>
      </div>
    );
  }
  return (
    <div className="page-container">
      <div className="container-fluid big-resolutions">
        <div className="row mb-4 px-md-4 pt-4">
          <div className="col-md-12">
            <Link
              to="/validar_contrato"
              className="btn btn-link p-0 btn-sm d-flex align-items-center mb-2"
              onClick={() =>
                createTrack('Clicou no botão voltar', {
                  fonte: 'Análise de contrato',
                })
              }
            >
              <i className="material-icons mr-1">arrow_back_ios</i>
              Voltar
            </Link>
            <ContractAnalysisReport
              analysis={contract_analysis?.detailed_contract}
              title="Análise de Cláusulas Contratuais"
            />
          </div>
        </div>
      </div>
      <AmbassadorToolFeedback toolSlug={CONTRACT_CLAUSES_AMBASSADOR_SLUG} />
    </div>
  );
};

export default DetailedContractAnalysis;
